import KCBTypeColumn from "components/common/ColumnColors/KCBTypeColumn/KCBTypeColumn";
import {
  birthday2Age,
  convertIosStringToDateDayjs,
  formatDateToString,
  convertDateStringToDateTimezone_7,
} from "helper/common";
import {formatPhoneNumber} from "helper/format-phone";
import moment, {now} from "moment";
import {FORMAT_TIME} from "types/enums";
import {ColumnProps} from "types/models";
import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";
import {loaiBNOptions} from "assets/constants/kbnt-category";
import PatientTypeColumn from "components/common/ColumnColors/KCBTypeColumn/PatientTypeColumn";
import ObjectTypeColumn from "components/common/ColumnColors/KCBTypeColumn/ObjectTypeColumn";
import KCBStatusColumn from "components/common/ColumnColors/KCBTypeColumn/KCBStatusColumn";
const receivedColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "stt",
    dataIndex: "stt",
    show: true,
    fixed: "left",
    // width: 70,
    align: "center",
    disabledCheck: true,
    isResizable: true,
  },
  {
    title: "Mã BN",
    key: "maBenhNhan",
    dataIndex: "maBenhNhan",
    align: "center",
    show: true,
    // width: 70,
    isResizable: true,
  },
  {
    title: "Mã PK",
    key: "idPhieuKham",
    dataIndex: "idPhieuKham",
    align: "center",
    // width: 70,
    show: true,
    isResizable: true,
  },
  {
    title: "Tên BN",
    key: "hoTen",
    dataIndex: "hoTen",
    align: "left",
    show: true,
    disabledCheck: true,
    // width: 150,
    isResizable: true,
  },
  {
    title: "Giới tính",
    key: "gioiTinh",
    dataIndex: "gioiTinh",
    show: true,
    render: text => {
      if (text == "0") {
        return "Nam";
      } else if (text == "1") {
        return "Nữ";
      } else return "";
    },
    align: "left",
    // width: 80,
    isResizable: true,
  },
  {
    title: "Ngày sinh",
    key: "ngaySinh",
    dataIndex: "ngaySinh",
    render: (text, record) =>
      text
        ? convertDateStringToDateTimezone_7(text).format(FORMAT_TIME.dayFull)
        : "",

    show: true,
    // width: 100,
    align: "center",
    isResizable: true,
  },
  {
    title: "Tuổi",
    key: "tuoi",
    dataIndex: "tuoi",
    render: (text, record: {ngaySinh: Date}) =>
      record.ngaySinh ? birthday2Age(record.ngaySinh) : "",
    show: true,
    // width: 80,
    align: "center",
    isResizable: true,
  },
  {
    title: "Số điện thoại",
    key: "sdt",
    dataIndex: "phoneNumber",
    show: true,
    disabledCheck: true,
    // width: 110,
    render: v => formatPhoneNumber(v),
    align: "right",
    isResizable: true,
  },
  {
    title: "Thời gian tiếp nhận",
    key: "ngayNhapVien",
    dataIndex: "ngayNhapVien",
    render: (text, record) =>
      text ? moment(text).format(FORMAT_TIME.dateTime) : "",
    show: true,
    width: 150,
    align: "center",
    isResizable: true,
  },

  {
    title: "Ngày tạo",
    key: "createdDate",
    dataIndex: "createdDate",
    render: (text, record) =>
      text ? moment(text).format(FORMAT_TIME.dateTime) : "",
    show: true,
    // width: 150,
    align: "center",
    isResizable: true,
  },
  {
    title: "Lần khám trước",
    key: "tgHoanThanhGanNhat",
    dataIndex: "tgHoanThanhGanNhat",
    render: (text, record) => {
      if (!text) {
        return 0;
      } else if (text) {
        const currentDate: Date = new Date();
        const specificDate: Date = new Date(text);

        const tgHT: number =
          (currentDate.getTime() - specificDate.getTime()) / (86400 * 1000);

        return isNaN(tgHT)
          ? 0
          : tgHT <= 30
          ? `${Math.round(tgHT)} ngày`
          : `${Math.round(tgHT / 30)} tháng`;
      }
    },
    align: "center",
    show: true,
    // width: 80,
    isResizable: true,
  },
  {
    title: "Tên thuốc",
    key: "tenThuoc",
    dataIndex: "tenThuoc",
    disabledCheck: true,
    show: true,
    // width: 100,
    isResizable: true,
  },
  {
    title: "Địa chỉ",
    key: "diaChiTongHop",
    dataIndex: "diaChiTongHop",
    show: true,
    // width: 200,
    isResizable: true,
  },

  {
    title: "Loại KCB",
    key: "loaiKCB",
    dataIndex: "loaiThamKham",
    show: true,
    // width: 150,
    disabledCheck: true,
    isResizable: true,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("loaiKCB")).find(
          option => option.value === text
        )?.label || "";
      return <KCBTypeColumn label={ten} />;
    },
  },
  {
    title: "Loại bệnh nhân",
    key: "loaiBenhNhans",
    dataIndex: "loaiBenhNhans",
    show: true,
    // width: 150,
    disabledCheck: true,
    isResizable: true,
    render: text => {
      const loaiBN =
        loaiBNOptions.find(option => option.value === text?.[0])?.label || "";
      return <PatientTypeColumn label={loaiBN} />;
    },
  },
  {
    title: "Đối tượng",
    dataIndex: "doiTuongKCB",
    key: "doiTuongKCB",
    show: true,
    align: "center",
    isResizable: true,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("doiTuong")).find(
          option => option.label === text
        )?.label || "";
      return <ObjectTypeColumn label={ten} />;
    },
  },
  {
    title: "Người thực hiện",
    key: "tenBsThucHien",
    dataIndex: "tenBsThucHien",
    show: true,
    // width: 130,
    isResizable: true,
  },
  {
    title: "Phòng",
    key: "idPhong",
    dataIndex: "idPhong",
    show: true,
    // width: 200,
    isResizable: true,
    render: text =>
      JSON.parse(localStorage.getItem("phongKhamNoPeople")).find(
        option => option.value === text
      )?.label || "",
  },

  {
    title: "Trạng thái KKX",
    key: "status",
    dataIndex: "status",
    show: true,
    disabledCheck: true,
    // width: 130,
    isResizable: true,
    render: text => {
      const ten =
        JSON.parse(localStorage.getItem("TTPhieu")).find(
          option => option.value === text
        )?.label || "";
      return <KCBStatusColumn label={ten} />;
    },
  },

  {
    // width: 150,
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    align: "center",
    show: true,
    fixed: "right",
    isResizable: true,
  },
];
export {receivedColumns};
